import React from "react";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import classNames from "classnames";
// import { Manager, Target, Popper } from "react-popper";
 import {
//   withStyles,
//   IconButton,
//   MenuItem,
//   MenuList,
//   Grow,
//   Paper,
   ClickAwayListener,
//   Button,
//   Hidden
 } from "@material-ui/core";

import { withStyles, Grid, InputLabel, FormControl, Typography,Info,Divider } from "@material-ui/core";

import Create from "@material-ui/icons/Create"

import {
  ProfileCard,
  RegularCard,
  Button,
  LoadingSpinner,
  CustomInput,
  ItemGrid,
  IconButton,
  label,
  CountryDropDownSelect,
  AddButton,
  AddInput,
  EditInput,
  ErrorNotification,
  InfoNotification
} from "../../components";
//import validation from '../../actions/validation'
import validate from '../../actions/validateWrapper'
import { withFirebase,withFirestore,firebaseConnect,isEmpty,isLoaded,firestoreConnect } from 'react-redux-firebase'
import { connect } from 'react-redux';
import {compose} from 'redux';
//import * as firebase from "firebase";

import avatar from "../../assets/img/faces/765-default-avatar.png";

class UserLinks extends React.Component {
    constructor(props) {
        super(props);
        this.editInputClick = this.editInputClick.bind(this);
        this.handlePassChange = this.handlePassChange.bind(this);
        this.state = {disabled: true,info:null,isLoading1: false,isLoading: false,error: null,ispasschange: false||"",country: '', region: ''};
        this.save = this.save.bind(this);
        this.confirm = this.confirm.bind(this);
        var globalcount;
        
      }

      onCountrySelect = (country) => {
      this.setState({ country: country});
      }

      handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
      };
    

  state = {
    clicked:false,
    countryError:"",
    showPassword: false,
    email: "",
    //country: "",
    firstName:"",
    firstNameError:"",
    lastName:"",
    lastNameError:"",
    displayName: "",
    //isLoading: false,
    //error: null,
    updateemail: "",
    oldpassword: "",
    oldPasswordError:"",
    newpassword:"",
    newPasswordError:"",
    updatecountry:"",
    names:"",
    names1:"",
    countrys:"",
    savesc:""
  };

  reauth = (oldpassword) => {
    const {firebase} = this.props
    var user = firebase.auth().currentUser;
    var cred = firebase.auth.EmailAuthProvider.credential(user.email, oldpassword);
    return user.reauthenticateAndRetrieveDataWithCredential(cred);
  }

  confirm = () => {
    const oldPasswordError = validate('password', this.state.oldpassword);
    const newPasswordError = validate('password', this.state.newpassword);

    this.setState({oldPasswordError:oldPasswordError,newPasswordError:newPasswordError});
    //event.preventDefault();

    if(!oldPasswordError &&!newPasswordError){
      this.setState({isLoading:true,error:null,info:null});
    if(this.state.oldpassword == undefined && this.state.newpassword == undefined){
      this.setState({isLoaded:false,error:"Please Edit Both Password Fields",isLoading:false});
      console.log("Password Fields Not Edited!!!")
    }
    else{
    this.reauth(this.state.oldpassword).then(() => {
      const {firebase} = this.props
      this.setState({isLoading:true,error:null,info:null});
      console.log("Confirm run");
      var user = firebase.auth().currentUser;
      user.updatePassword(this.state.newpassword).then(() => {
        console.log("PasswordUpdate");
        this.setState({info:"Password Updated",isLoading:false});
    }).catch((error) => {
        console.log(error);
        this.setState({error:error.message,isLoading:false});
    });

    }).catch((error) => {
      console.log("Confirm Clicked " + error)
      this.setState({error:error.message,isLoading:false})
    });
  }
  }
  }

  save(event){
    event.preventDefault();   
    //const {email,password} = this.state
    const firstNameRef = this.state.firstName;
    const lastNameRef = this.state.lastName;
    //const displayName = firstNameRef+ " " + lastNameRef; 
    const {firebase,route,auth,firestore,profile} = this.props;
    const {country,email,firstName,lastName} = this.state;

    var firstNameError;
    if(firstName==""){
      firstNameError = validate('names', firstNameRef);
    }
    else if(!this.state.names==""){
      firstNameError = validate('names', this.state.names);
    }

    var lastNameError;
    if(lastName==""){
      lastNameError = validate('names', lastNameRef);
    }
    else if(!this.state.names1==""){
      lastNameError = validate('names', this.state.names1);
    }
    console.log("this be it",this.state.savesc,country);
    var countryError;
    if(country==""&&this.state.savesc==""){
      countryError = validate('country', country);
    }
    else if(!this.state.countrys==""){
      countryError = validate('country', country);
    }
    // else if(!this.state.countrys==""&&!this.state.savesc==""){
    //   countryError = validate('country', this.state.savesc);
    // }
    

    this.setState({
      firstNameError:firstNameError,
      lastNameError:lastNameError,
      countryError:countryError,
    })

    if (!firstNameError && !lastNameError && !countryError) {

    if(lastNameRef!=undefined&&firstNameRef==(this.state.firstName)){
      this.setState({isLoading1:true,error:null,info:null})
      const displayName = firstNameRef+ " " + lastNameRef;
      firebase.updateProfile({  lastName: lastNameRef, displayName: displayName }).then(()=>{
        this.setState({isLoading1:false,info:"Details Updated"})
      }).catch((error)=>{
        console.error(error);
        this.setState({isLoading1:false,error:error.message,})
      })
    }

    if(firstNameRef!=undefined&&lastNameRef==(this.state.lastName)){
      this.setState({isLoading1:true,error:null,info:null})
      const displayName = firstNameRef+ " " + lastNameRef;
      firebase.updateProfile({  firstName: firstNameRef, displayName: displayName }).then(()=>{
        this.setState({isLoading1:false,info:"Details Updated"})
      }).catch((error)=>{
        console.error(error);
        this.setState({isLoading1:false,error:error.message})
      })
    }

    if(firstNameRef!=undefined&&lastNameRef!=undefined){
      this.setState({isLoading1:true,error:null,info:null})
      const displayName = firstNameRef+ " " + lastNameRef;
      firebase.updateProfile({ firstName: firstNameRef, lastName: lastNameRef, displayName: displayName }).then(()=>{
        this.setState({isLoading1:false,info:"Details Updated"})
      }).catch((error)=>{
        console.error(error);
        this.setState({isLoading1:false,error:error.message})
      })
    }

    if(country==("")&&!this.state.savesc==""){
      console.log("No country choosen");
    }
    else{
      this.setState({isLoading1:true,error:null,info:null})
      firebase.updateProfile({ country: country }).then(()=>{
        this.setState({isLoading1:false,info:"Details Updated"})
      }).catch((error)=>{
        console.error(error);
        this.setState({isLoading1:false,error:error.message})
      })
      console.log("country updated to "+country)
    }

  }
  }

  handlePassChange() {
    this.setState({ispasschange: !this.state.ispasschange});
    console.log("handlePass fired");
  }

  editInputClick() {
      console.log("Button is clicked")
    this.setState( {clicked: !this.state.clicked} )
    this.setState( {savesc:this.globalcount} );
  }

  render() {
    const {firebase,route,auth,firestore,classes,logout,profile,nextprofile} = this.props
    const { firstName,LastName,open,clicked,country,region,isLoading,error,info,isLoading1 } = this.state;
    //this.state = { firstname:'', lastname:''};

    const ispasschange = this.state.ispasschange
    var user = firebase.auth().currentUser;
    var name, email, photoUrl, uid, emailVerified;
    var firstname, lastname, dashcountry = '';
    if (user != null) {
        firstname = profile.firstName;
        lastname = profile.lastName; 
        dashcountry = profile.country;
        email = user.email;
        photoUrl = user.photoURL;
        emailVerified = user.emailVerified;
        this.globalcount = dashcountry;
        //country = user.country;
    }
    return (
      <div>
      {isLoaded(profile) ?
      <Grid container style={styles.cardcenter}>
        <ItemGrid xs={12} sm={12} md={8} style={styles.bordershadow}>
          <RegularCard 
            cardTitle={<div style={{display:"flex"}}>{email}
              <ItemGrid style={styles.headerinline}>
                  <IconButton style={styles.buttonedit} onClick={this.editInputClick.bind(this)} color="simple">
                  <Create style={styles.iconedit}> </Create>
                  </IconButton> 
                  </ItemGrid>
              </div>} //"Edit Proile"
            cardSubtitle="Your Profile"
            avatar={avatar}
            content={
              <div>
              {/* <ClickAwayListener onClickAway={this.handleClose}> */}

                <Grid container>
                
                  <ItemGrid xs={12} sm={12} md={8}>
                  { !this.state.clicked ?
                        <EditInput
                        value={firstname}
                      labelText="First Name"
                      id="first-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                       inputProps={{
                         disabled: true
                       }}
                    />                        
                      :
                       <EditInput
                      labelText="First Name"
                      inputProps={{
                        type: "text",
                        //autoFocus:true,
                        onChange: (event)=>{
                          let names = event.target.value
                          this.setState({firstName:event.target.value,
                          names:names
                          })
                        },
                        onBlur:() => {
                        this.setState({
                        firstNameError: validate('names', this.state.firstName)
                          })
                        }
                        //disabled: true
                        }}
                      // onBlur={() => {
                      //   this.setState({
                      //   firstNameError: validate('names', this.state.firstName)
                      //     })
                      // }}
                      id="first-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      error={this.state.firstNameError} 
                    />}
                  </ItemGrid>
                  </Grid>
                  <Grid container>
                  <ItemGrid xs={12} sm={12} md={8}>
                  { !this.state.clicked ?
                        <EditInput
                        value={lastname}                       
                      labelText="Last Name"
                      id="last-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />                        
                      :
                      <EditInput
                      labelText="Last Name"
                      id="last-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                       inputProps={{
                        type: "text",
                        onChange: (event)=>{
                          let names1 = event.target.value
                          this.setState({lastName:event.target.value,
                          names1:names1
                          })
                        },
                        onBlur:() => {
                        this.setState({
                        lastNameError: validate('names', this.state.lastName)
                          })
                       }
                       }}
                       error={this.state.lastNameError}
                    />}
          
                  </ItemGrid>
                </Grid>
                <Grid container>
                  <ItemGrid xs={12} sm={12} md={8}>
                  { !this.state.clicked ?
                        <EditInput                       
                      value={dashcountry}
                      labelText="Country"
                      id="country"
                      formControlProps={{
                        fullWidth: true
                      }}
                       inputProps={{
                        disabled: true
                       }}
                    />                        
                      :
                      <CountryDropDownSelect
                      value={country}
                      onChange={this.onCountrySelect}
                       labelText="Country"
                       formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type:"select",
                        onBlur:() => {
                        let countrys = this.onCountrySelect
                        this.setState({
                          countryError: validate('country', this.state.country),
                          countrys:countrys,
                          savesc:dashcountry
                          })
                       }
                      }}
                      error={this.state.countryError}
                     />
                      }
                  </ItemGrid>
                </Grid>
                <Grid container>
                <ItemGrid xs={12} sm={12} md={12}>
                  <div style={{color:"rgb(168, 168, 168)",fontSize:13,marginTop:15,cursor:"pointer"}} onClick={this.handlePassChange}>Change Password?</div>
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={8}>
                <AddInput ispasschange={ispasschange}
                onClick={this.handleClickShowPassword}
                labelText="Current Password"
                id="oldpassword"
                type={this.state.showPassword ? 'text' : 'password'}
                formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        //type:"password",
                        onChange: (event)=>{this.setState({oldpassword:event.target.value})},
                        onBlur:() => {
                        this.setState({
                          oldPasswordError: validate('password', this.state.oldpassword)
                          })
                       }                     
                       }}
                error={this.state.oldPasswordError}
                />
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={8}>
                <AddInput ispasschange={ispasschange}
                value={this.state.newpassword}
                onClick={this.handleClickShowPassword}
                labelText="New Password"
                id="newpassword"
                type={this.state.showPassword ? 'text' : 'password'}
                formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        //type:"password",
                        onChange: (event)=>{this.setState({newpassword:event.target.value})},
                        onBlur:() => {
                        this.setState({
                          newPasswordError: validate('password', this.state.newpassword)
                          })
                       }                             
                       }}
                       error={this.state.newPasswordError}
                />
                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={8}>
                {!isLoading?
                <AddButton ispasschange={ispasschange} color="primary" onClick={this.confirm}>Confirm</AddButton>
                :
                <LoadingSpinner/>
                }
                </ItemGrid>
                </Grid>
                {/* </ClickAwayListener> */}
              </div>
            }
            
            footer=
            {
              !this.state.clicked ?
              <div></div>
            : !isLoading1?
            <div style={{display:"flex"}}>          
            <Button color="primary" style={styles.rightside} onClick={this.save}>Save</Button>
             </div>
             : 
             <div style={{display:"flex"}}>
             <LoadingSpinner style={styles.rightside}/>
             </div>
            }
          />
        </ItemGrid>
      </Grid>
      :<div id="spinner" className="container">
  <div className="loader"></div>
</div>
      }
      {info&&
        <InfoNotification message={info}/>
      }
      {error&&
        <ErrorNotification message={error}/>
      }
      </div>
    );
  }
}
const styles = {
  label: {
    //...defaultFont,
    color: "#AAAAAA",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    //marginTop: "16px"
  },
    headerstyle:{
      backgroundColor:"#fc824e",
    },
    buttonedit:{
      paddingBottom: "10px",
      position: "relative",
    },
    formcontrol:{
      margin: "27px 0 0 0",
      position: "relative",
      paddingBottom: "10px",
    },
    iconedit:{
      marginTop: 7,
      color: "white"
    },
    headerinline:{
      display:"inline",
      marginLeft:"auto",
    },
    rightside: {
      marginLeft: "auto",      
    },
    // content:{
    //     paddingTop:200,
    //     maxWidth:400,
    //     margin:"auto",
    //     flexGrow:0.9,
    //     justifyContent:"center",
    //     textAlign:"center",
    //     padding:20
    // },
    // cardActions:{
    //     justifyContent:"flex-end"
    // },
   cardcenter:{
      marginTop:75
    }, 
    passwordButton:{
    color:"rgb(235, 235, 228);"
    },
    dropdown:{
      borderTop: "1px",
      padding: "6px 0 7px",
      // justifyContent:"center",
      // margin: "0 0 0 50px",
      position: "relative",
      //padding: "0 15px",
    },
    bordershadow: {
      boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",

    }
  
  };
  
export default compose(
  // firestoreConnect((props) => [
  //   {
  //     collection: 'users',
  //     doc: props.route.match.params.id,
  //     storeAs: "user"
  //   }
  // ]),
  withFirestore,
  withFirebase,
  connect(
    (state) => {
      return {
        profile: state.firebase.profile // profile passed as props.profile
      }
    }
  ),
  connect(
    ({ firebase: { nextprofile } },props) => ({
      nextprofile
    })
  ),
  withStyles(styles))(UserLinks);
;



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserLinks.jsx